<template>
  <div id="user-edit-account-details">
    <div class="vx-row">
      <div class="vx-col w-full">
        <h3>Tokens</h3>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-1/2">
        <vs-input class="w-full mt-4"
                  label="ID Token Expiration (in seconds)"
                  type="number"
                  v-model.number="data_local.ExternalIdentity.jwt_configuration.lifetime_in_seconds"
                  name="lifetime" />
        <span class="text-danger text-sm"  v-show="vErrors.has('lifetime_in_seconds')">{{
            vErrors.first('lifetime_in_seconds')
          }}</span>
      </div>
      <div class="vx-col w-1/2 mt-4" v-if="hasRefreshToken">
        <label class="vs-input--label mt-4">Refresh Token Refresh Behaviour</label>
        <v-select v-model="token_behaviour_local"
                  :clearable="false"
                  :options="tokenBehaviourOptions"
                  v-validate="'required'"
                  name="token_behaviour" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        <span class="text-danger text-sm"  v-show="vErrors.has('token_behaviour')">
          {{ vErrors.first('token_behaviour') }}
        </span>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-1/2 mt-4">
        <label class="vs-input--label mt-4">JsonWebToken Signature Algorithm</label>
        <v-select v-model="signature"
                  :clearable="false"
                  :options="signatureOptions"
                  v-validate="'required'"
                  :disabled="!canChangeSignature"
                  name="signature"  />
        <span class="text-danger text-sm"  v-show="vErrors.has('signature')">
          {{ vErrors.first('signature') }}
        </span>
      </div>
    </div>

  </div>
</template>

<script>

import vSelect from "vue-select";

export default {
  components: {
    vSelect
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.value)),
      tokenBehaviourOptions: [
        {
          label: 'Non-Rotating',
          value: 'non-rotating',
        },
        {
          label: 'Rotating',
          value: 'rotating',
        },
      ],
      signatureOptions: [
        {
          label: 'HS256',
          value: 'HS256',
        },
        {
          label: 'RS256',
          value: 'RS256',
        },
      ]
    }
  },
  computed: {
    hasRefreshToken() {
      return false;
      return this.data_local.ExternalIdentity.refresh_token !== null ||
          this.data_local.ExternalIdentity.oidc_conformant === true;
    },
    token_behaviour_local: {
      get() {
        const refresh_token = this.data_local.ExternalIdentity.refresh_token || {};
        const { rotationType } = refresh_token;
        return this.tokenBehaviourOptions
            .find(({value}) => value === rotationType);
      },
      set({value}) {
        this.data_local.ExternalIdentity.refresh_token.rotation_type = value;
      }
    },
    signature: {
      get() {
        return this.signatureOptions
            .find(({value}) => value === this.data_local.ExternalIdentity.jwt_configuration.alg);
      },
      set({value}) {
        this.data_local.ExternalIdentity.jwt_configuration.alg = value;
      }
    },
    canChangeSignature() {
      return this.data_local.ExternalIdentity.app_type !== 'spa';
    }
  },

  watch: {
    data_local: {
      handler(newData) {
        this.$emit('input', newData);
      },
      deep: true,
    },
  },
  mounted() {
    // We have to set this object up by default
    if (this.hasRefreshToken && !this.data_local.ExternalIdentity.refresh_token) {
      // Default
      this.data_local.ExternalIdentity.refresh_token = {
        expiration_type: 'non-expiring',
        leeway: 0,
        token_lifetime: 2592000
      };
    }
  },
}
</script>
